import { useEffect, useState, useCallback } from 'react';
import styles from './Popup.module.scss';
import PropTypes from 'prop-types';

export default function Popup(props) {
	const [state, setPopupState] = useState(false);
	const [popupAnimationState, setPopupAnimationState] = useState(false);

	const { onClose, popupState, children } = props;

	const popupHandler = useCallback(
		e => {
			if (!e) {
				setPopupAnimationState(false);
				setTimeout(() => {
					setPopupState(false);
					onClose(false);
				}, 200);
			} else {
				setPopupState(true);
				setTimeout(() => {
					setPopupAnimationState(true);
				}, 100);
			}
		},
		[onClose]
	);

	useEffect(() => {
		popupHandler(popupState);
	}, [popupState, popupHandler]);

	return (
		state && (
			<div className={styles.container}>
				<div className={`${styles.container__backdrop} ${popupAnimationState ? styles['container__backdrop--open'] : styles['container__backdrop--close']}`} onClick={() => popupHandler(false)}></div>
				<div className={`${styles.container__content} ${popupAnimationState ? styles['container__content--open'] : styles['container__content--close']}`}>{children}</div>
			</div>
		)
	);
}

Popup.propTypes = {
	state: PropTypes.bool,
	popupAnimationState: PropTypes.bool,
	onClose: PropTypes.any
};

Popup.defaultProps = {
	state: false,
	popupAnimationState: false,
	onClose: ''
};
